/**
 * @generated SignedSource<<f7cf5002a472fec64691cd564d3c5679>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type PhotoStatus = "ACTIVE" | "DELETED" | "PENDING" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSellerDetailsHeader_seller$data = {
  readonly isRewardsTier2: boolean | null;
  readonly liveStorefrontProfile: {
    readonly galleryAlbum: {
      readonly mediaList: ReadonlyArray<{
        readonly element: {
          readonly path?: string | null;
          readonly url?: string | null;
        } | null;
      } | null> | null;
    } | null;
    readonly headshots: ReadonlyArray<{
      readonly path: string | null;
      readonly status: PhotoStatus | null;
    } | null> | null;
  } | null;
  readonly monthsSinceStartDate: number | null;
  readonly sellerProfile: {
    readonly company: string | null;
  } | null;
  readonly serviceId: string | null;
  readonly shippingAddress: {
    readonly displayFullCityStateCountry: string | null;
  } | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSellerDetailsFeedback_seller" | "SharedStarRating_seller">;
  readonly " $fragmentType": "PdpSharedSellerDetailsHeader_seller";
};
export type PdpSharedSellerDetailsHeader_seller$key = {
  readonly " $data"?: PdpSharedSellerDetailsHeader_seller$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSellerDetailsHeader_seller">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "path",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSellerDetailsHeader_seller",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SharedStarRating_seller"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedSellerDetailsFeedback_seller"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": "isRewardsTier2",
      "args": [
        {
          "kind": "Literal",
          "name": "listName",
          "value": "SELLER_REWARDS_2"
        }
      ],
      "kind": "ScalarField",
      "name": "isAnchorListMember",
      "storageKey": "isAnchorListMember(listName:\"SELLER_REWARDS_2\")"
    },
    {
      "alias": "monthsSinceStartDate",
      "args": [
        {
          "kind": "Literal",
          "name": "unit",
          "value": "MONTH"
        }
      ],
      "kind": "ScalarField",
      "name": "timeSinceStartDate",
      "storageKey": "timeSinceStartDate(unit:\"MONTH\")"
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "SellerProfile",
      "kind": "LinkedField",
      "name": "sellerProfile",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "company",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "shippingAddress",
      "plural": false,
      "selections": [
        {
          "alias": "displayFullCityStateCountry",
          "args": [
            {
              "kind": "Literal",
              "name": "fullCountryName",
              "value": true
            }
          ],
          "kind": "ScalarField",
          "name": "displayCityStateCountry",
          "storageKey": "displayCityStateCountry(fullCountryName:true)"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "StorefrontProfile",
      "kind": "LinkedField",
      "name": "liveStorefrontProfile",
      "plural": false,
      "selections": [
        {
          "alias": "headshots",
          "args": [
            {
              "kind": "Literal",
              "name": "photoType",
              "value": "DEALER_STOREFRONT_HEADSHOT"
            }
          ],
          "concreteType": "Photo",
          "kind": "LinkedField",
          "name": "photos",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "status",
              "storageKey": null
            },
            (v0/*: any*/)
          ],
          "storageKey": "photos(photoType:\"DEALER_STOREFRONT_HEADSHOT\")"
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "MediaAlbum",
          "kind": "LinkedField",
          "name": "galleryAlbum",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "MediaElement",
              "kind": "LinkedField",
              "name": "mediaList",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "concreteType": null,
                  "kind": "LinkedField",
                  "name": "element",
                  "plural": false,
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        (v0/*: any*/)
                      ],
                      "type": "Photo",
                      "abstractKey": null
                    },
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "alias": null,
                          "args": null,
                          "kind": "ScalarField",
                          "name": "url",
                          "storageKey": null
                        }
                      ],
                      "type": "Video",
                      "abstractKey": null
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Seller",
  "abstractKey": null
};
})();

(node as any).hash = "596e7003bc3727f044a3ba5dcb4dcdc9";

export default node;
